<template>
  <main>
    <div class="container-fluid">
      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="real-time-content-tab" data-bs-toggle="pill" data-bs-target="#real-time-content"
            type="button" role="tab" aria-controls="real-time-content" aria-selected="true"> 即時 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="sum-content-tab" data-bs-toggle="pill" data-bs-target="#sum-content" 
            type="button" role="tab" aria-controls="sum-content" aria-selected="false">統計(日) </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="sum-content-month-tab" data-bs-toggle="pill" data-bs-target="#sum-content-month" 
            type="button" role="tab" aria-controls="sum-content-month" aria-selected="false">統計(月) </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="sum-content-year-tab" data-bs-toggle="pill" data-bs-target="#sum-content-year" 
            type="button" role="tab" aria-controls="sum-content-year" aria-selected="false">統計(年) </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="cross-center-tab" data-bs-toggle="pill" data-bs-target="#cross-center" 
            type="button" role="tab" aria-controls="cross-center" aria-selected="false">跨景區比較 </button>
        </li>
      </ul>

      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
         <real-time-content></real-time-content>
         <sum-content></sum-content>
         <sum-content-month></sum-content-month>
         <sum-content-year></sum-content-year>
         <cross-center></cross-center>
      </div>
    </div>
  </main>
</template>

<script>
import realTimeContent from './realTimeContent.vue';
import sumContent from './sumContent.vue'
import sumContentMonth from './sumContentMonth.vue'
import sumContentYear from './sumContentYear.vue'
import crossCenter from './crossCenter.vue'



export default {
  components: { realTimeContent, sumContent, sumContentMonth, sumContentYear, crossCenter},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
 
  },
  mounted() {

  },
};
</script>

<style>
</style>
